/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofileplacetitle3Inputs */

const en_setupprofileplacetitle3 = /** @type {(inputs: Setupprofileplacetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place`)
};

const de_setupprofileplacetitle3 = /** @type {(inputs: Setupprofileplacetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Place" |
*
* @param {Setupprofileplacetitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofileplacetitle3 = /** @type {((inputs?: Setupprofileplacetitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofileplacetitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofileplacetitle3(inputs)
	return de_setupprofileplacetitle3(inputs)
});
export { setupprofileplacetitle3 as "setupProfilePlaceTitle" }